module.exports = __webpack_public_path__ + "img/LogoFooter2.43ce3b89.png";